// import _ from 'lodash';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { emailRegExp, translationKoMsg } from '../../../../utils/utilityEtc';
import { useAlert, useInput, useUserInfo } from '../../../../hooks';
import { AuthNumForm, EmailForm as CommonEmailForm, MobileEmailAuthBtn } from '../common';
import { emailSendAPI, emailChangeAPI, emailVerifyAPI } from '../../../../api/accountAPI';
import useAmplitude from '../../../../hooks/useAmplitude';

let authEmail = '';
function EmailForm() {
  const { t } = useTranslation();
  const { info, setInfo } = useUserInfo();
  const { setAmplitudeLog } = useAmplitude();
  const [Alert] = useAlert();
  const [btnType, setBtnType] = useState("change");
  const [emailCheck, setEmailCheck] = useState('');
  const [authNumMsg, setAuthNumMsg] = useState('');
  const [email, onChangeEmail, onEmailReset] = useInput('');
  const [authNum, onChangeAuthNum, onAuthNumReset] = useInput('');

  const handleMouseDown = (e) => e.preventDefault();
  const onBlur = useCallback(() => {
    if (!email) return;
    // 이메일 양식이 맞으면  true 아니면 false;
    const result = emailRegExp(email);
    setEmailCheck(result ? 'success' : 'fail');
  }, [email]);

  // 변경하기, 인증하기, 재전송
  const handleChangeBtn = useCallback((type) => {
    onEmailReset("");
    onAuthNumReset("");
    setEmailCheck("");
    setBtnType(type);
  }, []);

  // 이메일 인증번호 받기
  const handleSend = useCallback(async () => {
    if (!email) return;
    const result = await emailSendAPI({
      emailAdrs: email,
      chnCd: info.channelCode,
    });

    if (result?.code === 'S000000') {
      setBtnType('resend');
      authEmail = email;
      Alert(t("MY_03_01.msg038"))
    } else {
      setBtnType('auth');
    }
  }, [email]);

  // 이메일 인증번호 확인
  // const handleAuthNum = useCallback(async () => {
  //   if (authNum.length < 4 || btnType !== 'resend') return;

  // }, [authNum])

  // 이메일 인증번호 확인 후 이메일 변경
  const handleEmailChange = useCallback(async () => {
    if (!authNum ||  btnType !== 'resend') return;
    
    // 이메일 인증 번호 확인
    const authResp = await emailVerifyAPI({
      emailAuthNo: authNum
    });

    if (authResp.code !== 'S000000') {
      setAuthNumMsg(translationKoMsg(authResp.code));
      return;
    } else {

      const changeResp = await emailChangeAPI({
        sbsceMbrId: info.userId,
        chnCd: info.channelCode,
        mbrId: info.userId,
        emailAdrs: authEmail,
      });

      if (changeResp?.code === 'S000000') {
        localStorage.setItem("access.email", authEmail);
        setInfo({ userEmail: authEmail });
        handleChangeBtn('change');
        setAmplitudeLog({ eventCategory: 'account', eventName: '회원 정보변경' });
        Alert(t("MY_03_01.msg039"));
      }
      setAuthNumMsg("");
    }
    
   

  }, [authNum, btnType]);

  return (
    <div className="item cls">
      <div className="input_title">{t("MY_03_01.msg002")}</div>
      <div className="input_cont pw">
        {btnType === 'change' && <div className="txt">{info.userEmail}</div>}
        <MobileEmailAuthBtn
          btnType={btnType}
          handleChangeBtn={handleChangeBtn}
          handleSend={handleSend}
        />
      </div>
      {
        btnType !== 'change' && (
          <div className="input_cont pw fr">
            <ul>
              <li>
                <CommonEmailForm
                  email={email}
                  onChangeEmail={onChangeEmail}
                  onBlur={onBlur}
                  emailCheck={emailCheck}
                  onEmailReset={onEmailReset}
                  handleMouseDown={handleMouseDown}
                  btnType={btnType}
                  handleSend={handleSend}
                />
              </li>
              <li>
                <AuthNumForm
                  authNum={authNum}
                  onChangeAuthNum={onChangeAuthNum}
                  authNumMsg={authNumMsg}
                  setAuthNumMsg={setAuthNumMsg}
                  onAuthNumReset={onAuthNumReset}
                  handleMouseDown={handleMouseDown}
                  btnType={btnType}
                />
              </li>
            </ul>
            <div className="btns cls">
              <div className="left">
                <button
                  type="button"
                  className="btn-small btn-gray"
                  onClick={() => handleChangeBtn('change')}
                >
                  {t("MY_03_01.msg004")}
                </button>
              </div>
              <div className="right">
                <button
                  disabled={btnType !== 'resend'}
                  className="btn btn-blue"
                  onClick={handleEmailChange}
                >
                  {t("MY_03_01-GM.msg010")}
                </button>
              </div>
            </div>
          </div>
        )
      }
    </div>
  );
}

export default EmailForm;